// extracted by mini-css-extract-plugin
export default {"pending":"State_pending__Llv9s","approved":"State_approved__BDLcc","denied":"State_denied__m3ngj"};